import { FaClock, FaChild, FaPaw, FaBan, FaSmokingBan } from "react-icons/fa"

const CancellationPolicy = () => {
  return (
    <div className="py-6">
      <h2 className="text-[26px] md:text-3xl font-bold mb-4">Cancellation Policy</h2>
      <div className="mb-2">
        <strong>100% refund</strong> up to 24 hours before arrival
      </div>
      <div className="mb-2">
        <strong>Non-refundable</strong> within 24 hours of event
      </div>
      <div className="flex items-center mb-2">
        <FaClock className="mr-2" />
        <span>Check-in: 2 PM</span>
      </div>
      <div className="flex items-center mb-2">
        <FaClock className="mr-2" />
        <span>Check-out: 12:30 PM</span>
      </div>
      <div className="flex items-center mb-2">
        <FaChild className="mr-2" />
        <span>Children: allowed</span>
      </div>
      <div className="flex items-center mb-2">
        <FaPaw className="mr-2" />
        <span>Pets: allowed</span>
      </div>
      <div className="flex items-center mb-2">
        <FaBan className="mr-2" />
        <span>Parties and events: not allowed</span>
      </div>
      <div className="flex items-center mb-2">
        <FaSmokingBan className="mr-2" />
        <span>Smoking inside: not allowed</span>
      </div>
    </div>
  )
}

export default CancellationPolicy
